import { Injectable } from '@angular/core';
import {ParentService} from '../A2-utils/ParentClass/ParentService';
import {Router} from '@angular/router';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {constant} from '../../app.constants';
import {Observable} from 'rxjs/Observable';
@Injectable()
export class MergeAccountService extends ParentService {
  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }

  /**
   * @description
   * @param data
   * @returns {Observable<any>}
   */
  putAccountsToMerge(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.put(constant.URL_MERGE_ACCOUNT, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/merge-account/merge-account.service.ts